export const ServicesData = [
  {
    title: "Web Development",
    description:
      "My expertise in web development allows me to design and code user-friendly and responsive websites, utilizing HTML, CSS, JavaScript and other frameworks, to bring clients' visions to life. ",
    image: "./images/web.png",
    id: 0,
  },
  {
    title: "WordPress Development ",
    description:
      "As a WordPress developer, I have expertise in building, managing, and updating WordPress websites, developing custom functionalities, and optimizing site speed and security to deliver seamless user experiences.",
    image: "./images/wordpress.png",
    id: 1,
  },
  {
    title: "API Integration",
    description:
      " I enable software applications to share data with each other, creating seamless workflows that save time, increase efficiency, and improve overall performance.",
    image: "./images/api.png",
    id: 2,
  },
  {
    title: "Landing Page and Funnel Building",
    description:
      " As a landing page and funnel building specialist, I design and develop high-converting pages and funnels that attract, engage, and convert leads, ultimately driving business growth and revenue.",
    image: "./images/landing.png",
    id: 2,
  },
];
